import type { ReactNode } from 'react';
import { navigate } from '../router';
import type { DirectorLanguage } from '@clutch/core';
import { pick } from '../director/i18n';

export function AppLink({ href, children, className, current }: { href: string; children: ReactNode; className?: string; current?: boolean }) {
  return <a href={href} className={className} aria-current={current ? 'page' : undefined} onClick={(e) => {
    if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    navigate(href);
  }}>{children}</a>;
}

export function FanNav({ current, language = 'en' }: { current?: 'home' | 'takes'; language?: DirectorLanguage }) {
  const c = pick({ en: { nav: 'Main navigation', home: 'Home', discover: 'Discover', takes: 'My takes' }, hi: { nav: 'मुख्य नेविगेशन', home: 'होम', discover: 'खोजें', takes: 'मेरे वीडियो' }, zh: { nav: '主导航', home: '首页', discover: '发现', takes: '我的反应' } }, language);
  return <nav className="fan-nav" aria-label={c.nav}>
    <AppLink href="/" className="wordmark" current={current === 'home'}>CLUTCH<span className="sr-only"> {c.home}</span></AppLink>
    <div><AppLink href="/" current={current === 'home'}>{c.discover}</AppLink><AppLink href="/takes" current={current === 'takes'}>{c.takes}</AppLink></div>
  </nav>;
}
